/**
 * Reads a cookie value from `document.cookie`.
 *
 * Returns `undefined` both when the cookie is absent and when it is present but
 * empty, so a caller has one case to handle rather than two.
 *
 * Safe to call during server-side rendering, where there is no `document`.
 */
export function readCookie(name: string): string | undefined {
    if (typeof document === 'undefined') {
        return undefined;
    }

    const prefix = `${name}=`;

    for (const part of document.cookie.split(';')) {
        const cookie = part.trim();
        if (cookie.startsWith(prefix)) {
            return decodeURIComponent(cookie.slice(prefix.length)) || undefined;
        }
    }

    return undefined;
}
